import axios from 'axios';

const API_BASE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' 
  ? 'http://localhost:8000/api' 
  : 'https://api.uzak.co/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  register: (data) => api.post('/register', data),
  login: (data) => api.post('/login', data),
  logout: () => api.post('/logout'),
  getUser: () => api.get('/user'),
  forgotPassword: (email) => api.post('/forgot-password', { email }),
  verifyResetCode: (email, code) => api.post('/verify-reset-code', { email, code }),
  resetPassword: (email, code, password, password_confirmation) => api.post('/reset-password', { email, code, password, password_confirmation }),
  becomeBuyer: (data) => api.post('/become-buyer', data),
};

export const companyAPI = {
  getAll: () => api.get('/companies'),
  getById: (id) => api.get(`/companies/${id}`),
  getAvailableSlots: (companyId, date) => {
    const params = date ? { date } : {};
    return api.get(`/companies/${companyId}/slots`, { params });
  },
};

export const meetingAPI = {
  create: (data) => api.post('/meetings', data),
  getUserMeetings: () => api.get('/my-meetings'),
  cancelMeeting: (meetingId) => api.post(`/meetings/${meetingId}/cancel`),
};

export const eventAPI = {
  getAll: () => api.get('/events'),
};

export default api;
